import { CKBadge } from 'clearkit';

import { usePlatformAccess } from '~/hooks/account/usePlatformAccess';

export default function UpgradePlanSection({ title, children, addon }) {
  const platformAccess = usePlatformAccess();
  const hasAccess = platformAccess[addon];

  return (
    <div className="flex flex-col mt-8 gap-4">
      <div className="flex justify-between">
        <div className="text-base font-medium">{title} add-on</div>
        {hasAccess && <CKBadge>Enabled for your team</CKBadge>}
      </div>

      {children}
    </div>
  );
}
